import React from "react"
import PortalLayers from "./PortalLayers";


export default function SmallPortal(props){

    return(
        <div className="portal-small">
            <PortalLayers 
                icon={props.icon}
                weathermain={props.weathermain}
                weatherdesc={props.weatherdesc}
            />
        </div>
    )
}